import { bunja } from 'bunja';
import { atom } from 'jotai';

import { perpAccountBunja, symbolBunja } from './base';
import { formBunja } from './form';

export const formSegmentDataBunja = bunja(() => {
  const { symbol } = bunja.use(symbolBunja);
  const form = bunja.use(formBunja);
  const { orderStateAtom } = bunja.use(formBunja);
  const { isOneWayAtom } = bunja.use(perpAccountBunja);

  const leverageAtom = atom((get) => {
    const state = get(orderStateAtom);
    return state.leverage;
  });

  type OrderByToken = 'margin' | 'quantity' | 'position_size';
  const orderByTokenAtom = atom<OrderByToken>((get) => {
    const state = get(orderStateAtom);
    return state.kind === 'margin' ? 'margin' : state.kind === 'quantity' ? 'quantity' : 'position_size';
  });

  type OrderType = 'market_order' | 'trigger_price_order' | 'trigger_time_order' | 'limit_order';
  const orderTypeAtom = atom<OrderType>((get) => {
    const priceType = get(form.priceTypeAtom);
    const triggerType = get(form.triggerTypeAtom);
    return priceType === 'market'
      ? 'market_order'
      : priceType === 'limit'
        ? 'limit_order'
        : triggerType === 'price'
          ? 'trigger_price_order'
          : 'trigger_time_order';
  });

  type PositionMode = 'oneway' | 'multiposition';
  const positionModeAtom = atom<PositionMode>((get) => {
    const isOneWay = get(isOneWayAtom);
    return isOneWay ? 'oneway' : 'multiposition';
  });

  return {
    symbol,
    leverageAtom,
    orderByTokenAtom,
    orderTypeAtom,
    positionModeAtom,
  };
});
formSegmentDataBunja.debugLabel = 'formSegmentDataBunja';
